<div class="row" *ngIf="(customer | json) != '{}'">
    <div class="col-sm-12">
        <div class="row" *ngIf="isLocked">
            <div class="col">
                <h2 class="text-danger">* Profile Locked</h2>
                <div>Profile edit for this customer is currently locked. Only team members can be updated.</div>
                <div><b>Locked By:</b> {{searchRecordLock.checkedOutByEmployeeName}}</div>
                <div><b>Date Locked:</b> {{searchRecordLock.dateCheckedOut | date:'medium'}}</div>
                <div><b>Lock Type:</b> {{searchRecordLock.recordLockTypeName}}</div>
                <div><b>Lock Source:</b> {{searchRecordLock.lockSource}}</div>
                <div class="float-right">
                    <button class="btn btn-danger" (click)="overrideRecordLock(searchRecordLock.recordID)">Override Lock</button>
                    <!--<button class="btn btn-primary" (click)="cancelOverride()">Cancel</button>-->
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Name</label>
            </div>
            <div class="col-sm-9">
                <input type="text" class="form-control" [(ngModel)]="customer.name" [disabled]="isLocked" required />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Customer Code</label>
            </div>
            <div class="col-sm-9">
                <input type="text" class="form-control" [(ngModel)]="customer.customerCode" [disabled]="true" />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Address</label>
            </div>
            <div class="col-sm-9">
                <input type="text" class="form-control" [(ngModel)]="customer.address1" [disabled]="!isCRMAdmin || isLocked" required />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Address 2</label>
            </div>
            <div class="col-sm-9">
                <input type="text" class="form-control" [(ngModel)]="customer.address2" [disabled]="!isCRMAdmin || isLocked" />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">City</label>
            </div>
            <div class="col-sm-9">
                <!--<city-dropdown [parentForm]="customerForm" [ctrlName]="'cityCtrl'" [placeholder]="'Select a City'"
            (citySelected)="cityChanged()" [cityId]="customer.cityId" [defaultCity]="defaultCustomerCity"
            [isRequired]="true"></city-dropdown>-->
                <city-state-zip-dropdown [parentForm]="customerForm" [ctrlName]="'cityStateZipCtrl'" [placeholder]="'Select a City'"
                                         (citySelected)="citySTChanged($event)" [defaultCity]="defaultCustomerCity" [cityID]="customer.cityId"
                                         [isDisabled]="!isCRMAdmin || isLocked" [isRequired]="true"></city-state-zip-dropdown>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Time Zone</label>
            </div>
            <div class="col-sm-9">
                <input type="text" class="form-control" [(ngModel)]="timeZoneName" [disabled]="true" />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Lat/Lon</label>
                <button (click)="getCoords()" class="btn btn-sml btn-success" title="Get Coordinates" tabindex="-1" *ngIf="customer.latitude==null||customer.longitude==null" [disabled]="isLocked"><i class="fas fa-search-location"></i></button>
            </div>
            <div class="col-sm-9">
                <input type="text" class="form-control" [(ngModel)]="customer.latitude" [disabled]="true" />
                <input type="text" class="form-control" [(ngModel)]="customer.longitude" [disabled]="true" />
            </div>
        </div>
        <!--<div class="row">
        <div class="col-sm-3">
            <label class="font-weight-bold">Sales Rep</label>
        </div>
        <div class="col-sm-9">
            <select name="salesRep" [(ngModel)]="customer.salesEmployeeId" class="form-select">
                <option *ngFor="let rep of salesReps" value="{{rep.employeeId}}">{{rep.fullName}}</option>
            </select>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-3">
            <label class="font-weight-bold">Ops Rep</label>
        </div>
        <div class="col-sm-9">
            <select name="opsRep" [(ngModel)]="customer.opsRepId" class="form-select">
                <option *ngFor="let rep of opsReps" value="{{rep.employeeId}}">{{rep.fullName}}</option>
            </select>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-3">
            <label class="font-weight-bold">Account Rep</label>
        </div>
        <div class="col-sm-9">
            <select name="accountRep" [(ngModel)]="customer.accountRepId" class="form-select">
                <option *ngFor="let rep of accountReps" value="{{rep.employeeId}}">{{rep.fullName}}</option>
            </select>
        </div>
    </div>-->
        <div class="row">
            <div class="col">
                <input type="checkbox" [(ngModel)]="customer.billToInd" [disabled]="isLocked" /> Bill To
                <input type="checkbox" [(ngModel)]="customer.shipperInd" [disabled]="isLocked" /> Shipper
                <input type="checkbox" [(ngModel)]="customer.consigneeInd" [disabled]="isLocked" /> Consignee
            </div>
        </div>
        <div class="row">
            <div class="col">
                <input type="checkbox" [(ngModel)]="customer.activeInd" [disabled]="true" /> Active
            </div>
        </div>
        <div class="row">
            <div class="col">
                <input type="checkbox" [(ngModel)]="customer.retiredInd" [disabled]="true" /> Retired
            </div>
        </div>
        <!--<div class="row" *ngIf="customer.contactTitleID!=3">
        <div class="col-sm-3">
            <label class="font-weight-bold">Phone</label>
        </div>
        <div class="col-sm-5">
            <kendo-maskedtextbox [mask]="phoneMask" class="form-control" type="text" [(ngModel)]="customer.phone"></kendo-maskedtextbox>
        </div>
        <div class="col-sm-2">
            <label class="font-weight-bold">Ext</label>
        </div>
        <div class="col-sm-2">
            <input type="text" class="form-control" [(ngModel)]="customer.phoneExt" />
        </div>
    </div>
    <div class="row">
        <div class="col-sm-3">
            <label class="font-weight-bold">Cell</label>
        </div>
        <div class="col-sm-9">
            <kendo-maskedtextbox [mask]="phoneMask" class="form-control" type="text" [(ngModel)]="customer.cell"></kendo-maskedtextbox>
        </div>
    </div>
    <div class="row" *ngIf="customer.contactTitleID!=3">
        <div class="col-sm-3">
            <label class="font-weight-bold">Fax</label>
        </div>
        <div class="col-sm-9">
            <kendo-maskedtextbox [mask]="phoneMask" class="form-control" type="text" [(ngModel)]="customer.fax"></kendo-maskedtextbox>
        </div>
    </div>
    <div class="row" *ngIf="customer.contactTitleID!=3">
        <div class="col-sm-3">
            <label class="font-weight-bold">Email</label>
        </div>
        <div class="col-sm-9">
            <input type="text" class="form-control" [(ngModel)]="customer.email" />
        </div>
    </div>
    <div class="row" *ngIf="customer.contactTitleID!=3">
        <div class="col-sm-3">
            <label class="font-weight-bold">Default</label>
        </div>
        <div class="col-sm-9">
            <input type="checkbox" [(ngModel)]="customer.defaultContactInd" style="transform:scale(1.5);" />
        </div>
    </div>-->
        <div class="row">
            <div class="col-sm-12">
                <customer-team-assigned [customerID]="customer.customerID" [pageType]="'edit customer'"></customer-team-assigned>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 m-2">
            <button class="btn btn-primary m-2" (click)="saveCustomer()" [disabled]="isLocked">Save</button>
            <button class="btn btn-secondary m-2" (click)="cancelCustomer()">Cancel</button>
        </div>
    </div>
</div>

<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay': isLoading}">
    <mat-spinner style="left: 50%; top: 50%" *ngIf="isLoading"></mat-spinner>
</div>
